interface OfflineState {
	isOffline: boolean
}

interface OfflineRootState {
	offline?: OfflineState
}

const defaultOfflineState: OfflineState = {
	isOffline: false,
}

const selectOffline = (state: Record<string, unknown>): OfflineState => {
	const offline = (state as OfflineRootState).offline
	return offline ?? defaultOfflineState
}

export default selectOffline
